/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// custom code start

(function () {

  function getSelectedVariant() {
    // ✅ Get active size
    const activeSizeEl = document.querySelector('.item_main .item_link.active');
    const size = activeSizeEl ? activeSizeEl.dataset.value.toUpperCase() : '';

    // ✅ Get ACTIVE category (important fix)
    const activeCategory = document.querySelector('.categorywise_selector.active');
    if (!activeCategory) return {};

    // ✅ Length & Width
    const lwEl = activeCategory.querySelector('#pdp-lw_selector');
    const lw = lwEl ? lwEl.value : '';

    const parts = lw.split('x');
    let length = parts[0];
    let width = parts[1];

    // ✅ Thickness
    const heightEl = activeCategory.querySelector('#pdp-height_selector');
    let thickness = heightEl ? heightEl.value : '';

    // ✅ Unit (inch / ft / cm)
    const unit = document.querySelector('input[name="pdp-unit_selector"]:checked')?.value || 'in';

    function convert(val) {
      val = parseFloat(val);
      if (isNaN(val)) return '';

      if (unit === 'ft') return (val / 12).toFixed(2) + ' ft';
      if (unit === 'cm') return (val * 2.54).toFixed(0) + ' cm';

      return val + '"';
    }

    const lwFormatted = (length && width) ? `${convert(length)} x ${convert(width)}` : '';
    const thicknessFormatted = thickness ? convert(thickness) : '';

    return { size, lwFormatted, thicknessFormatted };
  }

  function renderVariantSummary() {
    const { size, lwFormatted, thicknessFormatted } = getSelectedVariant();

    const parent = document.querySelector('.variant-show');
    if (!parent) return;

    let summaryEl = parent.querySelector('.selection-summary-text');

    if (!summaryEl) {
      summaryEl = document.createElement('p');
      summaryEl.className = 'selection-summary-text';
      summaryEl.style.cssText = `
        font-weight: 700;
        color: #3b1f6e;
        font-size: 15px;
        margin: 4px 0 0 0;
      `;
      parent.appendChild(summaryEl);
    }

    if (size) {
      summaryEl.innerHTML = `
        <span>${size}</span>
        <span> ${lwFormatted} x ${thicknessFormatted}</span>
      `;
      console.log('[Summary Updated]:', summaryEl.textContent);
    }
  }

  function initObservers() {

    // ✅ Size click (fix for Queen click not updating)
    document.addEventListener('click', function (e) {
      const sizeBtn = e.target.closest('.item_link');
      if (sizeBtn) {
        setTimeout(renderVariantSummary, 100);
      }
    });

    // ✅ Dropdown + Unit change
    document.addEventListener('change', function (e) {
      if (
        e.target.matches('#pdp-lw_selector') ||
        e.target.matches('#pdp-height_selector') ||
        e.target.matches('input[name="pdp-unit_selector"]')
      ) {
        setTimeout(renderVariantSummary, 100);
      }
    });

    // ✅ Observe active class change (extra safety)
    const itemMain = document.querySelector('.item_main');
    if (itemMain) {
      new MutationObserver(() => {
        setTimeout(renderVariantSummary, 100);
      }).observe(itemMain, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });
    }
  }

  // ✅ Init
  setTimeout(() => {
    renderVariantSummary();
    initObservers();
  }, 300);

})();


document.addEventListener("DOMContentLoaded", () => {
  const WORD_LIMIT = 20;
  
  if (window.innerWidth > 767) return;

  document.querySelectorAll(".short_desc").forEach(el => {
    const fullText = el.textContent.trim();
    const words = fullText.split(/\s+/);

    if (words.length <= WORD_LIMIT) return;

    const shortText = words.slice(0, WORD_LIMIT).join(" ");

    let isExpanded = false;

    const render = () => {
      if (!isExpanded) {
        el.innerHTML = `
          ${shortText}
          <span class="dots">...</span>
          <span class="toggle-text" style="cursor:pointer;"> Read More</span>
        `;
      } else {
        el.innerHTML = `
          ${fullText}
          <span class="toggle-text" style="cursor:pointer;"> Show Less</span>
        `;
      }

      el.querySelector(".toggle-text").addEventListener("click", () => {
        isExpanded = !isExpanded;
        render();
      });
    };

    render();
  });
});

// custom code end

$(function() {
  if(window.location.hash === '#opencartdrawer') {
      document.getElementById('mini-cart').open = true;
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }

  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  $('.your-comfort_wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    dots: true,
    infinite:false,
    responsive: [
      {
        breakpoint: 1000,
        settings: 'unslick'
      }
    ]
  });

  $(window).on('resize', function() {
      $('.carousel').slick('resize');
  });

  $('.multi-col-inr-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    dots: true,
    infinite:false,
    responsive: [
      {
        breakpoint: 1000,
        settings: 'unslick'
      }
    ]
  });

  $('.dream_sto-vdo-img-inr').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite:false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.recommandation_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev"><svg id="Group_467560" data-name="Group 467560" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><path id="Path_329635" data-name="Path 329635" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#fff"/><path id="Path_310229" data-name="Path 310229" d="M.155.155a.532.532,0,0,1,.751,0L5.137,4.387a.529.529,0,0,1,0,.748L.906,9.366a.53.53,0,0,1-.751-.748L4.016,4.761.155.9A.529.529,0,0,1,.155.155Z" transform="translate(17.52 19.583) rotate(180)" fill="#000" fill-rule="evenodd"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg id="Group_467560" data-name="Group 467560" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><path id="Path_329635" data-name="Path 329635" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#fff"/><path id="Path_310229" data-name="Path 310229" d="M.155.155a.532.532,0,0,1,.751,0L5.137,4.387a.529.529,0,0,1,0,.748L.906,9.366a.53.53,0,0,1-.751-.748L4.016,4.761.155.9A.529.529,0,0,1,.155.155Z" transform="translate(17.52 19.583) rotate(180)" fill="#000" fill-rule="evenodd"/></svg></button>',
  });

  $('.multi-col-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<button type="button" class="slick-prev"><svg id="Group_467560" data-name="Group 467560" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><path id="Path_329635" data-name="Path 329635" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#f9f7fb"/><path id="Path_310229" data-name="Path 310229" d="M.155.155a.532.532,0,0,1,.751,0L5.137,4.387a.529.529,0,0,1,0,.748L.906,9.366a.53.53,0,0,1-.751-.748L4.016,4.761.155.9A.529.529,0,0,1,.155.155Z" transform="translate(17.52 19.583) rotate(180)" fill="#c8bed3" fill-rule="evenodd"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg id="Group_467560" data-name="Group 467560" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><path id="Path_329635" data-name="Path 329635" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#f9f7fb"/><path id="Path_310229" data-name="Path 310229" d="M.155.155a.532.532,0,0,1,.751,0L5.137,4.387a.529.529,0,0,1,0,.748L.906,9.366a.53.53,0,0,1-.751-.748L4.016,4.761.155.9A.529.529,0,0,1,.155.155Z" transform="translate(17.52 19.583) rotate(180)" fill="#c8bed3" fill-rule="evenodd"/></svg></button>',
    infinite:false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('body').on('change','.product .layer_selector select', function(){
    var _this = $(this);
    var url = $(this).val();  
    window.location.href = url; 
  });

  $('body').on('click','.product .sizeguide-modal .tab_toggler .tab_selector', function(){
    var _this = $(this);
    _this.closest('.tab_flex_wrap').find('.tab_selector').removeClass('active');
    _this.addClass('active');
    var url = $(this).attr('data-taburl');
    $.get(url, function( data ) {            
      _this.closest('.model_content_wrapper').find('.tab-content-main').html($(data).find('.sizeguide-modal  .model_content_wrapper .tab-content-main').html());      
    }); 
  });
  
  function selectvalue(selector){ 
    if(selector.find('.variant_seperator[data-index="0"]').val() != null && selector.find('.variant_seperator[data-index="1"]').val() != null){
      $('.product__info .default_price_set').remove();
      var value1 = selector.find('.variant_seperator[data-index="0"]').val().replace('x',' x ');
      var value2 = selector.find('.variant_seperator[data-index="1"]').val();
      return value1 + ' x ' + value2;        
    }else{
      return null;
    }    
  }

  $('body').on('change','.product .categorywise_selector .variant_seperator', function(){
    var selectionvalue = selectvalue($(this).closest('.categorywise_selector'));
    if(selectionvalue == null){
      $('.product-form__add-button').attr('type','button').removeAttr('data-product-add-to-cart-button','').attr('disabled','');
      return;
    }
    var varproductData = JSON.parse(document.getElementById('productJson').textContent);
    var selectedvariant = varproductData.product.variants.filter(variant => {
      return variant.title == selectionvalue.toUpperCase()
    })
    console.log(selectedvariant);
    if(selectedvariant[0]){
      if(selectedvariant[0].available){
        console.log('ifff')
        $('.product-form__add-button').attr('type','submit').attr('data-product-add-to-cart-button','').removeAttr('disabled');
        var btntext = $('.product-form__add-button').attr("data-button-content")
      }else{
        console.log('elsss')
        $('.product-form__add-button').attr('type','button').attr('data-product-add-to-cart-button','').attr('disabled','disabled');
        var btntext = window.themeVariables.strings.productFormSoldOut
      }
    }else{
      console.log('eslslslslsl')
      $('.product-form__add-button').attr('type','button').attr('data-product-add-to-cart-button','').attr('disabled','disabled');
      var btntext = window.themeVariables.strings.productFormUnavailable
    }
    $('.product-form__add-button').find('.regular_text').text(btntext);
    $(this).closest('.custom_selector').find('.selector_wrapper').val(selectionvalue).trigger('change');
    $('[name="properties[Custom size]"]').remove();
  });

  $('body').on('click','.product .item_toggler .item_link', function(){
    $(this).closest('.item_main').find('.item_link').removeClass('active');
    $(this).addClass('active');
    $(this).closest('product-variants').find('.categorywise_selector').removeClass('active').addClass('hidden-phone hidden-tablet-and-up')
    $(this).closest('product-variants').find('.categorywise_selector[data-currentcat="'+$(this).attr('data-value')+'"]').addClass('active').removeClass('hidden-phone hidden-tablet-and-up');
    var selectionvalue = selectvalue($(this).closest('product-variants').find('.categorywise_selector.active'));  
    if(selectionvalue == null){
      $('.product-form__add-button').attr('type','button').removeAttr('data-product-add-to-cart-button','').attr('disabled','');
      return;
    }
    var varproductData = JSON.parse(document.getElementById('productJson').textContent);
    var selectedvariant = varproductData.product.variants.filter(variant => {
      return variant.title == selectionvalue.toUpperCase()
    })
    console.log(selectedvariant);
    if(selectedvariant[0]){
      if(selectedvariant[0].available){
        $('.product-form__add-button').attr('type','submit').attr('data-product-add-to-cart-button','').removeAttr('disabled');
        var btntext = $('.product-form__add-button').attr("data-button-content")
      }else{
        $('.product-form__add-button').attr('type','button').attr('data-product-add-to-cart-button','').attr('disabled','disabled');
        var btntext = window.themeVariables.strings.productFormSoldOut
      }
    }else{
      $('.product-form__add-button').attr('type','button').attr('data-product-add-to-cart-button','').attr('disabled','disabled');
      var btntext = window.themeVariables.strings.productFormUnavailable
    }
    $('.product-form__add-button').find('.regular_text').text(btntext);
    
    $(this).closest('product-variants').find('.selector_wrapper').val(selectionvalue).trigger('change');
    $('[name="properties[Custom size]"]').remove();
    $('.main-prices-wrapper').removeClass('is-render');
  });

  // Custom height dropdown - toggle open/close
  $('body').on('click', '.custom-height-dropdown__toggle', function(e){
    e.stopPropagation();
    var $dropdown = $(this).closest('.custom-height-dropdown');
    $('.custom-height-dropdown').not($dropdown).removeClass('open');
    $dropdown.toggleClass('open');
  });

  // Custom height dropdown - select option
  $('body').on('click', '.custom-height-dropdown__list .height-option', function(){
    var $item = $(this);
    var val = $item.attr('data-value');
    var $dropdown = $item.closest('.custom-height-dropdown');

    $dropdown.find('.height-option').removeClass('active');
    $item.addClass('active');

    // Update toggle display
    $dropdown.find('.custom-height-dropdown__selected').html($item.html());

    // Close dropdown
    $dropdown.removeClass('open');

    // Sync hidden select and trigger change (both jQuery + native for all listeners)
    var $select = $dropdown.siblings('select.variant_seperator, select.cs-field__select');
    $select.val(val).trigger('change');
    $select[0].dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Close dropdown when clicking outside
  $(document).on('click', function(){
    $('.custom-height-dropdown').removeClass('open');
  });

  $('body').on('change','.mattress_product_form .custom_selector .unit_selector input[name="pdp-unit_selector"]', function(){  
    var _this = $(this);
    // $(this).closest('.dimensions_list').find('.measure_link').removeClass('active');
    // $(this).addClass('active');
    $(this).closest('product-variants').find('.categorywise_selector').each(function(){      
      $(this).find('select').each(function(i, e){
        $(this).find('option').each(function(i, e){
          if($(e).val() != ''){
            var txtval = $(e).val().toLowerCase().replaceAll(" ", "").replaceAll('Inches','').trim();
            if(txtval.indexOf('x') > -1){
              var splittext = txtval.split('x');
              if(_this.val() == 'ft'){
                var mainval1 = parseInt(splittext[0]) / 12;
                var mainval2 = parseInt(splittext[1]) / 12;
                var feetvalue = `${mainval1.toFixed(2)} Ft x ${mainval2.toFixed(2)} Ft`;
              }else if(_this.val() == 'cm'){
                var mainval1 = 2.54 * parseInt(splittext[0]);
                var mainval2 = 2.54 * parseInt(splittext[1]);
                var feetvalue = `${mainval1.toFixed(2)} CM x ${mainval2.toFixed(2)} CM`;
              }else{
                var mainval1 = parseInt(splittext[0]);
                var mainval2 = parseInt(splittext[1]);
                var feetvalue = `${mainval1} Inches x ${mainval2} Inches`;
              }
                              
            }else{
              if(_this.val() == 'ft'){
                var mainval1 = parseInt(txtval) / 12;
                var feetvalue = `${mainval1.toFixed(2)} Ft`;
              }else if(_this.val() == 'cm'){
                var mainval1 = 2.54 * parseInt(txtval);
                var feetvalue = `${mainval1.toFixed(2)} CM`;
              }else{
                var mainval1 = parseInt(txtval);
                var feetvalue = `${mainval1} Inches`;
              }       
            }
            $(e).text(feetvalue);
          }
        });
      });

      // Also update custom height dropdown visible text
      $(this).find('.custom-height-dropdown .height-option').each(function(){
        var rawVal = $(this).attr('data-value').replace(/\s/g, '');
        var converted = '';
        if(_this.val() == 'ft'){
          converted = (parseInt(rawVal) / 12).toFixed(2) + ' Ft';
        } else if(_this.val() == 'cm'){
          converted = (2.54 * parseInt(rawVal)).toFixed(2) + ' CM';
        } else {
          converted = parseInt(rawVal) + ' Inch';
        }
        $(this).find('.height-option__text').text(converted);
      });

      // Update the toggle display with the active option's new text
      var $activeOption = $(this).find('.custom-height-dropdown .height-option.active');
      if($activeOption.length){
        $activeOption.closest('.custom-height-dropdown').find('.custom-height-dropdown__selected').html($activeOption.html());
      }
    });
  });

  $('body').on('click','#custom-size-popup .customsize_selector', function(){  
    var customvalues = [];
    var customvaluesH = [];
    var _this = $(this);
    $(this).closest('.model_content_wrapper').find('.custom-size-field-wp .input').each(function(i,e){
      customvalues.push($(this).find('input,select').val());    
    });
    var seperate = customvalues.join(' x ').split(' x ');
    var l = seperate[0], w = seperate[1], h = seperate[2];
    l = parseFloat(l);
    w = parseFloat(w);
    h = parseFloat(h);
    if (l == '' || w == '' || h == '') {
      $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.blank_msg).fadeIn().delay(3000).fadeOut('fast');      
    } else if (/^-?\d+(\.\d+)?$/.test(l) == false || /^-?\d+(\.\d+)?$/.test(w) == false) {      
      $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.alphabet_err_msg).fadeIn().delay(3000).fadeOut('fast');      
    } else if (l < 10 || w < 10 || l > 95 || w > 95) {
      // alert('Please ensure that you have added your dimensions in inches and not in feet/cms');
      $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.oversize_msg).fadeIn().delay(3000).fadeOut('fast');          
    } else if (String(l).indexOf('.') > -1 || String(w).indexOf('.') > -1){
      // alert('Please ensure that you have added your dimensions without any decimals');
      $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.decimal_val_msg).fadeIn().delay(3000).fadeOut('fast');      
    } else {
      var prddata = JSON.parse($('#productJson').html());
      var filteredSizeArr;
      filteredSizeArr = prddata.product.variants.filter(function(v){
        // if(v['available']){
          var sizeOpt = v['title'].toLowerCase().replaceAll(' ','').trim();
          var sizeOptArr = sizeOpt
          .trim()
          .split('x');
          var v_len = parseFloat(sizeOptArr[0].trim());
          var v_width = parseFloat(sizeOptArr[1].trim());
          var v_height = parseFloat(sizeOptArr[2].trim());                  
          return v_len == l && v_width == w && v_height == h ;
        // } else {
        //   return 0;
        // }
      });
      if(filteredSizeArr.length == 0){
        filteredSizeArr = prddata.product.variants.filter(function(v){
          // if(v['available'] && filteredSizeArr.length == 0){
            var sizeOpt = v['title'].toLowerCase().replaceAll(' ','').trim();
            var sizeOptArr = sizeOpt
            .trim()
            .split('x');
            var v_len = parseFloat(sizeOptArr[0].trim());
            var v_width = parseFloat(sizeOptArr[1].trim());
            var v_height = parseFloat(sizeOptArr[2].trim());                  
            return v_len >= l && v_width >= w && v_height >= h ;
          // } else {
          //   return 0;
          // }
        });
      }
      if(filteredSizeArr.length == 0){
        $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.sizenotfound).fadeIn().delay(3000).fadeOut('fast');      
        return false;
      }
      var foundvallw = '', foundvalh = '', foundedelement, foundvar = 0;
      var sizeOpt = filteredSizeArr[0]['title'].toLowerCase().replaceAll(' ','').trim();
      var sizeOptArr = sizeOpt
      .trim()
      .split('x');
      var finall = parseFloat(sizeOptArr[0].trim());
      var finalw = parseFloat(sizeOptArr[1].trim());
      var finalh = parseFloat(sizeOptArr[2].trim());
      $('.product product-variants .categorywise_selector').each(function(){
        // var innl = [], innw = [], innh = [];   
        if($(this).find('.select.variant_seperator:eq(0) option[value="'+finall +'x'+finalw+'"]').length > 0 &&
          $(this).find('.select.variant_seperator:eq(1) option[value="'+finalh +'"]').length > 0){
            foundvallw = finall +'x'+finalw;
            foundvalh = finalh;
            foundedelement = $(this);
            return false; 
          }        
      });
      
      if(foundedelement){
        foundedelement.find('.select[data-index="0"]').val(foundvallw).trigger('change');
        foundedelement.find('.select[data-index="1"]').val(foundvalh).trigger('change');
        foundedelement.closest('product-variants').find('.item_main .item_link').removeClass('active');
        foundedelement.closest('product-variants').find('.item_toggler .item_link[data-value="'+ foundedelement.closest('.categorywise_selector').attr('data-currentcat') +'"]').addClass('active');
        foundedelement.closest('product-variants').find('.categorywise_selector').removeClass('active').addClass('hidden-phone hidden-tablet-and-up')
        foundedelement.addClass('active').removeClass('hidden-phone hidden-tablet-and-up');
        _this.closest('#custom-size-popup').removeAttr('open');
        $('.custom-size-selector .button-content-main').find('.selected_msg').remove();
        $('.custom-size-selector .button-content-main').append('<span class="selected_msg">size selected - '+l+'X'+w+'X'+h+'</span>');
        var formid = $('.select#selector_wrapper_custom').attr('form');
        $('.select#selector_wrapper_custom').after('<input type="hidden" form="'+formid+'" name="properties[Custom size]" value="'+l+'X'+w+'X'+h+'">');
        $('.afteratc.custom-size-form-error').remove();
        if($('#AddToCart[data-product-add-to-cart-button]').attr('disabled')){
          $('#AddToCart[data-product-add-to-cart-button]').after('<div class="afteratc custom-size-form-error">Your selected custom size is not available</div>');
          setTimeout(function(){
            $('.afteratc.custom-size-form-error').remove();
          }, 5000);
          // $('#AddToCart[data-product-add-to-cart-button]').trigger('click');
        }else{
          $('#AddToCart[data-product-add-to-cart-button]').trigger('click');
        }
        
      }else{
        $('.custom-size-form-error').addClass('error').html(window.themeVariables.settings.sizenotfound).fadeIn().delay(3000).fadeOut('fast');      
      }
    }
    
  });

  $('body').on('change','#sizeguide-popup .sizeguide-modal .size_measurement select', function(){  
    var _this = $(this);
    // $(this).closest('.dimensions_list').find('.measure_link').removeClass('active');
    // $(this).addClass('active');
    $(this).closest('.tab-content-main').find('.size_value').each(function(){      
      // $(this).find('select').each(function(i, e){
      //   $(this).find('option').each(function(i, e){
          var txtval = $(this).attr('data-val').toLowerCase().replaceAll(" ", "").replaceAll('Inches','').trim();
          if(txtval.indexOf('x') > -1){
            var splittext = txtval.split('x');
            if(_this.val() == 'ft'){
              var mainval1 = parseInt(splittext[0]) / 12;
              var mainval2 = parseInt(splittext[1]) / 12;
              var mainval3 = parseInt(splittext[2]) / 12;
              var feetvalue = `${mainval1.toFixed(2)} x ${mainval2.toFixed(2)} x ${mainval3.toFixed(2)} Ft`;
            }else if(_this.val() == 'cm'){
              var mainval1 = 2.54 * parseInt(splittext[0]);
              var mainval2 = 2.54 * parseInt(splittext[1]);
              var mainval3 = 2.54 * parseInt(splittext[2]);
              var feetvalue = `${mainval1.toFixed(2)} x ${mainval2.toFixed(2)} x ${mainval3.toFixed(2)} CM`;
            }else{
              var mainval1 = parseInt(splittext[0]);
              var mainval2 = parseInt(splittext[1]);
              var mainval3 = parseInt(splittext[2]);
              var feetvalue = `${mainval1} x ${mainval2} x ${mainval3} Inches`;
            }
                            
          }else{
            if(_this.val() == 'ft'){
              var mainval1 = parseInt(txtval) / 12;
              var feetvalue = `${mainval1.toFixed(2)} Ft`;
            }else if(_this.val() == 'cm'){
              var mainval1 = 2.54 * parseInt(txtval);
              var feetvalue = `${mainval1.toFixed(2)} CM`;
            }else{
              var mainval1 = parseInt(txtval);
              var feetvalue = `${mainval1} Inches`;
            }       
          }
          $(this).text(feetvalue);
      //   });
      // });
    });
  });
  
  // Set the date we're counting down to
  $('body').find('.countdown_timer').each(function(i, v){
    var _this = this;
    var time = $(this).attr('data-time');
    var countDownDate = new Date(time).getTime();
  
    // Update the count down every 1 second
    var x = setInterval(function() {
  
      // Get today's date and time
      var now = new Date().getTime();
  
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
  
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      // Display the result in the element with id="demo"
      if(days > 1){
        var daytext = 'days';
      }else{
        var daytext = 'day';
      }
      $(_this).html(days + " "+ daytext + ' ' + hours + " hrs " + minutes + " mins " + seconds + " sec");
  
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        $(_this).closest('.offer_endsin').hide();
      }
    }, 1000);
  
  });  

  var width = $(window).outerWidth();
    console.log(width)
    if(width<=999){
      $('body').on('click','.footer__item--links .footer__item-title', function(){
      $(this).toggleClass('active');
      $(this).next('.footer__item-content').slideToggle();
      }) 
    } 

  // $('body').on('change','#discount_code',function(){
  //   var val = $(this).val();
  //   if(val != 'none'){
  //     $('.discount-code-apply-wrapper').find('.discount-code').val(val);
  //     $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');
  //   }else{      
  //     $('.discount-code-apply-wrapper').find('.success-msg').hide();
  //     $('.discount-price-wrapper').find('.discount-price,.total-price,.shipping-total').hide();
  //     $('.err-msg').hide();
  //     $('.err-msg').show().html('The requirements to avail the discount have not been fulfilled.');
  //     setCookie('discountcode',false,-1);      
  //   }
  // });
  
  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }

  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }

  $('body').on('keyup','#coupon_code_input', function(){
    if($(this).val().length > 0){
      $(this).closest('.cart-coupon_offer-input').find('.offer_button').show();
    }else{
      $(this).closest('.cart-coupon_offer-input').find('.offer_button').hide();
    }
  });

  function existingDiscounts(){
    const discountCodes = [];
    const discountPills = $('.codes_list_wp').find('.cart-discount__pill');
    for (const pill of discountPills) {
      if (typeof $(pill).attr('data-discount-code') === 'string') {
        discountCodes.push($(pill).attr('data-discount-code'));
      }
    }
    
    return discountCodes;
  }

  function animateCurrency($el, duration = 1000) {
    // Extract number only: "Rs. 10,581" → 10581
    const text = $el.text();
    const number = parseInt(text.replace(/[^0-9]/g, ''), 10);

    // Extract prefix (currency)
    const prefix = text.replace(/[0-9,]/g, '').trim() + ' ';

    $el.text(prefix + '0');

    $({ count: 0 }).stop(true).animate(
      { count: number },
      {
        duration: duration,
        easing: 'swing',
        step: function () {
          $el.text(prefix + Math.floor(this.count).toLocaleString('en-IN'));
        },
        complete: function () {
          $el.text(prefix + number.toLocaleString('en-IN'));
        }
      }
    );
  }


  $('body').on('click','[data-inputapply]', function(){
    $('.offer_input_err').remove();
    var _this = $(this);
    var sectionId = _this.closest('cart-drawer').attr('section');
    var discountCodeValue = _this.closest('.cart-coupon_offer-input').find('#coupon_code_input').val();
    if(discountCodeValue == ''){
      _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Please enter any code above.</p>');
      return;
    }
    _this.attr('aria-busy', true);
    var existingDiscountsValue = existingDiscounts();
    
    if (existingDiscountsValue.includes(discountCodeValue)) return;
    
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          discount: [...existingDiscountsValue, discountCodeValue].join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      if (data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Discount code cannot be applied to your cart</p>');
        _this.attr('aria-busy', false);
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: data
        }
      }));

      setTimeout(function(){
        const totalAllocatedAmount =
          data.cart_level_discount_applications.find(d =>
            d.discount_application?.title?.toLowerCase() === discountCodeValue?.toLowerCase()
          )?.discount_application.total_allocated_amount || 0;

        console.log(totalAllocatedAmount);
        $('.discount_success_popup .discount_code').html(discountCodeValue);
        $('.discount_success_popup .totl_discount_amnt').html(formatMoney(totalAllocatedAmount));
        // $('.discount_success_popup [data-totaldiscount]').html(formatMoney(data.total_discount));

        const $amountEl = $('.discount_success_popup .animated-amount');
        $amountEl.text(formatMoney(data.total_discount));
        animateCurrency($amountEl);
        $('.discount_success_popup').addClass('active');

        setTimeout(function(){
          $('.discount_success_popup').removeClass('active');
        },3000);
      }, 800);
      
      

      // const newHtml = data.sections[sectionId];
      // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      // console.log(parsedHtml);

      // $('#mini-cart')
      //   .children()
      //   .not('.discount_success_popup')
      //   .each(function () {
      //     $(this).html(
      //       $(parsedHtml).find(this).html()
      //     );
      //   });
      
      
      _this.attr('aria-busy', false);
    });
  });

  $('body').on('click','[data-removecode]', function(){
    var sectionId = $(this).closest('cart-drawer').attr('section');
    var discountCodeValue = $(this).closest('.cart-discount__pill').attr('data-discount-code');
    var existingDiscountsValue = existingDiscounts();
    
    const index = existingDiscountsValue.indexOf(discountCodeValue);
    if (index === -1) return;

    existingDiscountsValue.splice(index, 1);
    
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ 
          discount: existingDiscountsValue.join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      // const newHtml = data.sections[sectionId];
      // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      // console.log(parsedHtml);
      // $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
      // $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: data
        }
      }));
    });
  });

  $('body').on('click','.awesome_button_wp .close_popup', function(){
    $(this).closest('.discount_success_popup').removeClass('active');
  });

  $('body').on('click','.discount-price-wrapper .total_price_main', function(){
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      $(this).closest('.discount-price-wrapper').find('.payment-summary-list').slideUp();
    }else{
      $(this).addClass('active');
      $(this).closest('.discount-price-wrapper').find('.payment-summary-list').slideDown();
    }
  });

  $('body').on('click','.coupon_discount_widget .applied_code_header', function(){
    $(this).closest('.applied_code_details').find('.codes_list_wp').slideToggle();
    $(this).find('.dropdown_arrow').toggleClass('active');
  });

  if($('product-sticky-form').length > 0 && $(window).width() < 1000){
    $(window).scroll(function() {
      var scrollDistance = 200;
      var scrollTop = $(this).scrollTop();
      var windowHeight = $(this).height();
      var footer = $('.footer');
      
      // Check if footer exists and if user scrolled to footer
      var footerReached = false;
      if (footer.length > 0) {
        var footerTop = footer.offset().top;
        footerReached = (scrollTop + windowHeight) >= footerTop;
      }
      
      if (scrollTop > scrollDistance && !footerReached) {
        $('product-sticky-form').addClass('forcevisible');
      } else {
        $('product-sticky-form').removeClass('forcevisible');
      }
    }); 
  }

  function updateBuyPriceUI(variant) {
    const buyPricesWrapper = document.querySelector('.buy-button-prices-wrapper');

    if (!buyPricesWrapper || !variant) return;

    const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;

    const salePrice = variant.price;
    const comparePrice = variant.compare_at_price || salePrice;
    const ppn = Math.round(salePrice / 100 / 5475);

    buyPricesWrapper.innerHTML = `
      <div>
        <span class="label">Subtotal:</span>
        <span class="price price--highlight price--large offer_price">
          ${formatMoney(salePrice, currencyFormat)}
        </span>
        <span class="price regular_price">
          <span class="price price--compare mrp_price">
            ${formatMoney(comparePrice, currencyFormat)}
          </span>
        </span>
      </div>
      <span class="price pricepernight"><b>₹${ppn}</b> Per Night</span>
    `;
  }

  document.addEventListener("DOMContentLoaded", () => {
    const variant = document.querySelector('input[name="id"]')?.value;

    // If your theme exposes selected variant globally (most Shopify themes do)
    const selectedVariant = window.product?.selected_or_first_available_variant;

    if (selectedVariant) {
      updateBuyPriceUI(selectedVariant);
    }
  });
  document.addEventListener("variant:changed", (event) => {
    const variant = event.detail.variant;

    const carouselSelector = "product-media .product__media-list";
    const thumbnailsSelector = "product-media .product__thumbnail-list-inner";

    window.updateVariantImageInSlider(carouselSelector, thumbnailsSelector, variant);

    updateBuyPriceUI(variant);
  });
  // document.addEventListener("variant:changed", (event) => {
  //   const variant = event.detail.variant;
  //   const carouselSelector = "product-media .product__media-list"; // Replace with your carousel selector
  //   const thumbnailsSelector = "product-media .product__thumbnail-list-inner"; // Replace with your thumbnails selector
  
  //   window.updateVariantImageInSlider(carouselSelector, thumbnailsSelector, variant);
  //   // Update buy-button-prices-wrapper with new variant price
  //   const buyPricesWrapper = document.querySelector('.buy-button-prices-wrapper');
  //   if (buyPricesWrapper && variant) {
  //       const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
  //         ? window.themeVariables.settings.moneyWithCurrencyFormat
  //         : window.themeVariables.settings.moneyFormat;
  //       const salePrice = variant.price;
  //       const comparePrice = variant.compare_at_price || salePrice;
  //       const ppn = Math.round(salePrice / 100 / 5475);

  //       buyPricesWrapper.innerHTML = `
  //         <div>
  //           <span class="label">Subtotal:</span>
  //           <span class="price price--highlight price--large offer_price">
  //             ${formatMoney(salePrice, currencyFormat)}
  //           </span>
  //           <span class="price regular_price">
  //             <span class="price price--compare mrp_price">
  //               ${formatMoney(comparePrice, currencyFormat)}
  //             </span>
  //           </span>
  //         </div>
  //         <span class="price pricepernight"><b>₹${ppn}</b> Per Night</span>
  //       `;
  //   }
  // });

  document.addEventListener('minidrawer:update', function(event) {     
    $('.recommandation_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      prevArrow: '<button type="button" class="slick-prev"><svg id="Group_467560" data-name="Group 467560" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><path id="Path_329635" data-name="Path 329635" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#fff"/><path id="Path_310229" data-name="Path 310229" d="M.155.155a.532.532,0,0,1,.751,0L5.137,4.387a.529.529,0,0,1,0,.748L.906,9.366a.53.53,0,0,1-.751-.748L4.016,4.761.155.9A.529.529,0,0,1,.155.155Z" transform="translate(17.52 19.583) rotate(180)" fill="#000" fill-rule="evenodd"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg id="Group_467560" data-name="Group 467560" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><path id="Path_329635" data-name="Path 329635" d="M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z" fill="#fff"/><path id="Path_310229" data-name="Path 310229" d="M.155.155a.532.532,0,0,1,.751,0L5.137,4.387a.529.529,0,0,1,0,.748L.906,9.366a.53.53,0,0,1-.751-.748L4.016,4.761.155.9A.529.529,0,0,1,.155.155Z" transform="translate(17.52 19.583) rotate(180)" fill="#000" fill-rule="evenodd"/></svg></button>',
    });
  });

  $('body').on('change','.drawer_rec_options input, .drawer_rec_options select', function(){
    var selector = $(this).closest('.drawer_rec_options');
    var values = [];
    for(var i = 0;i < 3;i++){
      if(selector.find('[data-index="'+i+'"]').length > 0){
        if(selector.find('[data-index="'+i+'"] input[type="radio"]').length > 0){
          values.push(selector.find('[data-index="'+i+'"] input[type="radio"]:checked').val());
        }else{
          values.push(selector.find('[data-index="'+i+'"]').val());
        }
      }
    }
    
    if(values.length > 0){
      if(values.length > 1){
        values = values.join(' / ');  
      }else{
        values = values[0];
      }
      var selectedoption = $(this).closest('form').find('[name="id"] option[data-title="'+values+'"]');
      $(this).closest('form').find('[name="id"]').val(selectedoption.attr('value')).trigger('change');
      var pricehtml = ``;
      if(parseInt(selectedoption.attr('data-price')) < parseInt(selectedoption.attr('data-comp_price'))){
        pricehtml += `<span class="compare">${formatMoney(selectedoption.attr('data-comp_price'))}</span>
                      <span class="price">${formatMoney(selectedoption.attr('data-price'))}</span>`;
      }else{
        pricehtml += `<span class="price">${formatMoney(selectedoption.attr('data-price'))}</span>`;
      }
      $(this).closest('.cart-reco-item').find('.cart-reco-price').html(pricehtml);
      if(selectedoption.attr('data-available') == 'true'){
        console.log('ifff')
        $(this).closest('.cart-reco-item').find('[data-recommandation-atc]').removeAttr('disabled').find('.btn_text').text('Add');
      }else{
        $(this).closest('.cart-reco-item').find('[data-recommandation-atc]').attr('disabled','disabled').find('.btn_text').text('Sold out');
        console.log('elssss')
      }
    }    
  });

  $('body').on('click','[data-recommandation-atc]', function(evt){
    var __this = this;
    __this.setAttribute('aria-busy', true);
    
    var form = $(this).closest('[data-type="card-customform"]').get(0);
    var drawercart = document.querySelector('cart-drawer'); 
    const formData = new FormData(form);
    fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // This is needed for the endpoint to properly return 422
      }
    }).then((response) => response.json())
    .then((response) => {

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      
    });

    
  });

  if($('[createCustomerForm]').length > 0){
   $('body').on('submit','[createCustomerForm]', function (e) {
      e.preventDefault(); // Prevent form submission
       var _this = $(this);
     _this.find('.banner--success,.banner--error').hide();
      const phone = '91'+_this.find('#phone').val();
      const phoneRegex = /^[0-9]{12,15}$/; // Adjust for valid phone format
  
      // Basic Validation
      if (!phoneRegex.test(phone)) {
        _this.find('.banner--error').show().find('.banner__content').html("Please enter a valid 10 digit number without any space.");
        return;
      }
  
      $.ajax({
        url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
        method: "POST",
        contentType:"application/json",
        headers: {
          "Authorization": "9d0e24f04a754d4c8cf069c2e619614a"
        },
        data: JSON.stringify({
          phone: phone,
          tag: 'hush newsletter'
        }),
        success: function (response) {
          console.log(response);
          if(response.status == 1){
            _this.find('.banner--success .banner__content').html(response.message);
            _this.find('.banner--success').show();  
          }else{
            _this.find('.banner--error .banner__content').html(response.message);
            _this.find('.banner--error').show();
          }
          
        },
        error: function (xhr, status, error) {
          console.log(xhr, status, error);
          _this.find('.banner--error').show();
        }
      });
                   
    }); 
  }  

  $(document).on('click', '.custom-rating_loox', function (e) {
    e.preventDefault();

    var $target = $('#looxReviewsFrame');
    if (!$target.length) return;

    var headerHeight = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
      .trim();

    headerHeight = parseInt(headerHeight) + 100 || 0;

    // Get sticky container height (if exists)
    var stickyHeight = $('.sticky_container').outerHeight() || 0;

    // Total offset
    var totalOffset = headerHeight + stickyHeight;

    var targetPosition = $target.offset().top - totalOffset;

    $('html, body').animate(
      { scrollTop: targetPosition },
      600
    );
  });
});



// ------------- PDP Scroll Top Section -------------

// const leftBlock = document.querySelector('.product-media-wrapper');

// function handleScroll(e) {
//   const leftScrollable = leftBlock.scrollTop + leftBlock.clientHeight < leftBlock.scrollHeight;
//   const scrollingUp = e.deltaY < 0;
//   const leftAtTop = leftBlock.scrollTop === 0;
//   const pageAtTop = window.scrollY === 0;

//   if (scrollingUp) {
//     if (pageAtTop && !leftAtTop) {
//       e.preventDefault();
//       leftBlock.scrollTop += e.deltaY;
//     }
//   } else {
//     // Scrolling down
//     if (leftScrollable) {
//       e.preventDefault();
//       leftBlock.scrollTop += e.deltaY;
//     } else {
//       // Left is done, scroll the page manually when cursor is on left block
//       e.preventDefault();
//       window.scrollBy(0, e.deltaY);
//     }
//   }
// }

// // Listen on both window AND left block
// window.addEventListener('wheel', handleScroll, { passive: false });
// leftBlock.addEventListener('wheel', handleScroll, { passive: false });

const leftBlock = document.querySelector('.product-media-wrapper');

function handleScroll(e) {
  e.preventDefault();

  const scrollingUp = e.deltaY < 0;

  // Add 1px tolerance to fix floating point rounding on older browsers
  const leftScrollable = leftBlock.scrollTop + leftBlock.clientHeight < leftBlock.scrollHeight - 1;
  const leftAtTop = leftBlock.scrollTop <= 1;
  const pageAtTop = window.scrollY <= 1;

  if (scrollingUp) {
    if (pageAtTop && !leftAtTop) {
      // Scroll the gallery back up
      leftBlock.scrollTop += e.deltaY;
    } else {
      // Scroll the page up normally
      window.scrollBy(0, e.deltaY);
    }
  } else {
    // Scrolling down
    if (leftScrollable) {
      // Gallery hasn't finished — scroll it
      leftBlock.scrollTop += e.deltaY;
    } else {
      // Gallery is done — scroll the page
      window.scrollBy(0, e.deltaY);
    }
  }
}

// Only attach to window — NOT to leftBlock (prevents double-firing)
window.addEventListener('wheel', handleScroll, { passive: false });




function setupPriceToggle() {
  let timeout;

  const target = document.querySelector('.total_price');
  const trigger = document.querySelector('.total__hey');

  if (!target || !trigger) return;

  const activate = (isHover = false) => {
    target.classList.add('active');

    // Only apply timeout for click, not hover
    if (!isHover) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        target.classList.remove('active');
      }, 5000);
    }
  };

  const deactivate = () => {
    target.classList.remove('active');
    clearTimeout(timeout);
  };

  const handleTriggerClick = (e) => {
    e.stopPropagation();

    if (target.classList.contains('active')) {
      deactivate();
    } else {
      activate(false); // click
    }
  };

  const handleDocumentClick = () => {
    deactivate();
  };

  const handleMouseEnter = () => {
    clearTimeout(timeout); // stop click timeout if hovering
    activate(true); // hover mode
  };

  const handleMouseLeave = () => {
    deactivate(); // remove immediately on hover out
  };

  // Cleanup old listeners
  trigger.removeEventListener('mouseenter', handleMouseEnter);
  trigger.removeEventListener('mouseleave', handleMouseLeave);

  // Add listeners
  trigger.addEventListener('mouseenter', handleMouseEnter);
  trigger.addEventListener('mouseleave', handleMouseLeave);
}

setupPriceToggle();

document.addEventListener('variant:changed', () => {
  setTimeout(() => {
    setupPriceToggle();
  }, 100);
});

